import { TEF_INTERNAL_ACTIONS } from '../actions/tefInternalActions';

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		importFile:     false,
		tefLastUpdate:  false,
		generateResult: false,
		sendEmails:     false,
		extensionsHistory:        false,
		repoImport:     false,
		repoLastUpdate: false,
		repoExport:     false,
	},
	tef: {
		lastUpdate: {
			user:      null,
			timestamp: null,
		},
		sendEmailsResult: null,
		extensionsHistory: null,
		error:   null,
	},
	repository: {
		lastUpdate: {
			user:      null,
			timestamp: null,
			file:      null,
		},
		list:  [],
		error: null,
	},
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const tefReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Import File ────────────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.TEF_IMPORT_REQUEST:
						return { ...state, loading: { ...state.loading, importFile: true }, tef: { ...state.tef, error: null } };

					case TEF_INTERNAL_ACTIONS.TEF_IMPORT_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, importFile: false },
							tef: { ...state.tef, error: null },
						};

					case TEF_INTERNAL_ACTIONS.TEF_IMPORT_FAILURE:
						return {
							...state,
							loading: { ...state.loading, importFile: false },
							tef: { ...state.tef, error: action.error },
						};

						// ── TEF Get Last Update ────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_REQUEST:
						return { ...state, loading: { ...state.loading, tefLastUpdate: true } };

					case TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, tefLastUpdate: false },
							tef: { ...state.tef, lastUpdate: action.payload, error: null },
						};

					case TEF_INTERNAL_ACTIONS.TEF_GET_LAST_UPDATE_FAILURE:
						return {
							...state,
							loading: { ...state.loading, tefLastUpdate: false },
							tef: { ...state.tef, error: action.error },
						};

						// ── Generate Result ────────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.TEF_GENERATE_REQUEST:
						return { ...state, loading: { ...state.loading, generateResult: true }, tef: { ...state.tef, error: null } };

					case TEF_INTERNAL_ACTIONS.TEF_GENERATE_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, generateResult: false },
							tef: { ...state.tef, error: null },
						};

					case TEF_INTERNAL_ACTIONS.TEF_GENERATE_FAILURE:
						return {
							...state,
							loading: { ...state.loading, generateResult: false },
							tef: { ...state.tef, error: action.error },
						};

						// ── Send Emails ────────────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_REQUEST:
						return { ...state, loading: { ...state.loading, sendEmails: true } };

					case TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, sendEmails: false },
							tef: { ...state.tef, sendEmailsResult: action.payload },
						};

					case TEF_INTERNAL_ACTIONS.TEF_SEND_EMAILS_FAILURE:
						return {
							...state,
							loading: { ...state.loading, sendEmails: false },
							tef: { ...state.tef, error: action.error },
						};

						// ── Extensions History ─────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_REQUEST:
						return { ...state, loading: { ...state.loading, extensionsHistory: true } };

					case TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, extensionsHistory: false },
							tef: { ...state.tef, extensionsHistory: action.payload },
						};

					case TEF_INTERNAL_ACTIONS.TEF_EXTENSIONS_HISTORY_FAILURE:
						return {
							...state,
							loading: { ...state.loading, extensionsHistory: false },
							tef: { ...state.tef, error: action.error },
						};

						// ── Repository Import ──────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.REPO_IMPORT_REQUEST:
						return { ...state, loading: { ...state.loading, repoImport: true }, repository: { ...state.repository, error: null } };

					case TEF_INTERNAL_ACTIONS.REPO_IMPORT_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, repoImport: false },
							repository: { ...state.repository, error: null },
						};

					case TEF_INTERNAL_ACTIONS.REPO_IMPORT_FAILURE:
						return {
							...state,
							loading: { ...state.loading, repoImport: false },
							repository: { ...state.repository, error: action.error },
						};

						// ── Repository Get Last Update ─────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_REQUEST:
						return { ...state, loading: { ...state.loading, repoLastUpdate: true } };

					case TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, repoLastUpdate: false },
							repository: {
								...state.repository,
								lastUpdate: action.payload.lastUpdate,
								list:       action.payload.list,
								error:      null,
							},
						};

					case TEF_INTERNAL_ACTIONS.REPO_GET_LAST_UPDATE_FAILURE:
						return {
							...state,
							loading: { ...state.loading, repoLastUpdate: false },
							repository: { ...state.repository, error: action.error },
						};

						// ── Repository Export ──────────────────────────────────────────────────────
					case TEF_INTERNAL_ACTIONS.REPO_EXPORT_REQUEST:
						return { ...state, loading: { ...state.loading, repoExport: true }, repository: { ...state.repository, error: null } };

					case TEF_INTERNAL_ACTIONS.REPO_EXPORT_SUCCESS:
						return {
							...state,
							loading: { ...state.loading, repoExport: false },
							repository: { ...state.repository, error: null },
						};

					case TEF_INTERNAL_ACTIONS.REPO_EXPORT_FAILURE:
						return {
							...state,
							loading: { ...state.loading, repoExport: false },
							repository: { ...state.repository, error: action.error },
						};

					default:
						return state;
	}
};

export default tefReducer;